module.exports = __webpack_public_path__ + "static/media/tyrant.ead711af.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/tyrant.jpg
 ** module id = 442
 ** module chunks = 0
 **/